import React, { useState, useEffect } from "react";
import { Typography, Button, Box } from "@mui/material";
import { DataGridPro } from '@mui/x-data-grid-pro';
import ReportToolbar from "../ReportToolbar";
import ReportFooter from "../ReportFooter";
import axios from "axios";
import { APIURL } from "../../../config";

export default function BillingOutstandingBalanceReport(props) {
    const columns = [
        {
            field: "claim_ID",
            headerName: "Claim ID",
            width: 100,
        },
        {
            field: "PatientName",
            headerName: "Patient Name",
            width: 150,
        },
        {
            field: "Plan_Name",
            headerName: "Plan Name",
            width: 125,
        },
        {
            field: "Service_Date",
            headerName: "Service Date",
            width: 100,
        },
        {
            field: "ClaimBalance",
            headerName: "Outstanding Balance",
            width: 125,
        },
        {
            field: "ClaimStatus",
            headerName: "Status",
            width: 100,
        },
    ];

    const rows = props.data.outstanding.map((claim, index) => ({
        id: index,
        claim_ID: claim.Claim_ID,
        PatientName: claim.Patient_Name,
        Plan_Name: claim.Plan_Name,
        ClaimBalance: claim.Balance,
        ClaimStatus: claim.Status,
        Service_Date: claim.Service_Date,
    }
    ));

    const totalRow = {
        id: 'total-row',
        claim_ID: '',
        PatientName: '',
        Plan_Name: '',
        Service_Date: 'TOTAL:',
        ClaimBalance: props.data.balTotal,
        ClaimStatus: '',
        isTotal: true,
    };

    const CustomToolbar = () => {
        return (
            <ReportToolbar companyName={props.user.company_name} reportTitle="Billing Outstanding Balance Report">
                <Box sx={{ pl: 1, pr: 1 }}>
                    <div style={{ fontSize: '16px', fontWeight: 'bold' }}>Carrier Name: Medicaid</div>
                    <div style={{ display: 'flex' }}>
                        <div style={{ fontSize: '16px', fontWeight: 'bold', marginRight: '25px' }}>From Service Date: {props.data.from}</div>
                        <div style={{ fontSize: '16px', fontWeight: 'bold' }}>To Service Date: {props.data.to}</div>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <div style={{ fontSize: '16px', fontWeight: 'bold', marginRight: '25px' }}>From Bill Date: {props.data.from}</div>
                        <div style={{ fontSize: '16px', fontWeight: 'bold' }}>To Bill Date: {props.data.to}</div>
                    </div>
                </Box>
            </ReportToolbar>
        );
    };

    return (
        <div style={{ width: '100%' }}>
            <div style={{ height: '80vh' }}>
                <DataGridPro
                    initialState={{ sorting: { sortModel: [{ field: "Service_Date", sort: "desc" }] } }}
                    getRowId={(row) => row.id}
                    rows={rows}
                    columns={columns}
                    slots={{
                        toolbar: CustomToolbar,
                        footer: ReportFooter
                    }}
                    pinnedRows={{ bottom: [totalRow] }}
                    getRowClassName={(params) => {
                        return params.row.isTotal ? 'total-row' : '';
                    }}
                    sx={{
                        '& .total-row': {
                            backgroundColor: '#f5f5f5',
                            fontWeight: 'bold',
                            borderTop: '2px solid #ddd',
                            '&:hover': {
                                backgroundColor: '#f0f0f0',
                            }
                        }
                    }}
                    checkboxSelection={false}
                    disableRowSelectionOnClick
                    disableVirtualization
                    showToolbar
                />
            </div>
        </div>
    );
}